// eslint-disable-next-line import/no-internal-modules
import UserCell from '@insided/deprecated-control/overview/cells/UserCell'

import { SegmentData } from '../types'

const OverviewUsernameCell = ({ segment: { created_by: createdBy } }: SegmentData) => {
  const iconSize = 24
  if (!createdBy) {
    return ''
  }

  return UserCell('user', iconSize)({
    user: {
      id: createdBy.user_id,
      username: createdBy.username,
      avatar: createdBy.avatar
    }
  })
}

export default OverviewUsernameCell
